export default "__VITE_ASSET__a5c079fe__"